__webpack_require__.p = "https://static-spa-offer.uniplaces.com/_next/";